(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["victory-collection"]) return;
  try {
    
(function () {
  'use strict';

  /* ---- Sort auto-submit ---- */
  var sortSelect = document.querySelector('[data-vcoll-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---- Filter drawer toggle ---- */
  var drawer = document.querySelector('[data-vcoll-drawer]');
  var scrim  = document.querySelector('[data-vcoll-scrim]');
  var openBtns  = document.querySelectorAll('[data-vcoll-drawer-open]');
  var closeBtns = document.querySelectorAll('[data-vcoll-drawer-close]');
  if (!drawer) return;

  var lastFocused = null;

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    /* Update aria-expanded on all open buttons */
    Array.prototype.forEach.call(openBtns, function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    /* Focus the close button inside the drawer */
    var closeBtn = drawer.querySelector('[data-vcoll-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
    Array.prototype.forEach.call(openBtns, function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (lastFocused) lastFocused.focus();
  }

  Array.prototype.forEach.call(openBtns, function (btn) {
    btn.addEventListener('click', openDrawer);
  });
  Array.prototype.forEach.call(closeBtns, function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  if (scrim) {
    scrim.addEventListener('click', closeDrawer);
  }

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* Trap focus inside the drawer when open */
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusable = drawer.querySelectorAll(
      'button, [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* One-click filtering: auto-submit on checkbox change inside the drawer */
  var form = drawer.querySelector('[data-vcoll-form]');
  if (form) {
    form.addEventListener('change', function (event) {
      var t = event.target;
      if (t && t.matches('input[type="checkbox"]')) {
        form.submit();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["victory-search-results"]) return;
  try {
    
(function () {
  "use strict";
  var forms = document.querySelectorAll("form[data-victory-refine]");
  Array.prototype.forEach.call(forms, function (form) {
    var controls = form.querySelectorAll("[data-auto-submit]");
    Array.prototype.forEach.call(controls, function (control) {
      control.addEventListener("change", function () {
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
